import React, { ReactElement } from 'react';
import cn from 'classnames';
import { AuthLayoutProps } from 'layouts/auth/types';
import { renderRoutes, RouteConfig } from 'react-router-config';
import { isSsr } from 'utils';

export function AuthLayout(props: AuthLayoutProps): ReactElement {
  const { route } = props;

  if (isSsr()) return null;

  return (
    <div
      className={cn(
        'auth-layout',
        'odin-flex odin-items-center',
        'odin-bg-white',
        'odin-border-top',
        'odin-border-top-2',
        'odin-border-odin-primary',
      )}
    >
      {renderRoutes(route.routes as RouteConfig[])}
    </div>
  );
}
